import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldAlert } from 'lucide-react';

export const NotFound = () => {
  return (
    <div className="font-sans bg-[#Fcfcfc] text-gray-900 min-h-screen flex items-center justify-center px-4 py-16">
      <main className="w-full max-w-3xl text-center">
        <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-2xl bg-red-50 text-red-600 border border-red-100">
          <ShieldAlert className="h-10 w-10" />
        </div>

        <p className="text-sm font-extrabold uppercase tracking-[0.3em] text-red-600 mb-4">404</p>
        <h1 className="text-4xl sm:text-6xl font-black tracking-tight text-gray-900 mb-6">
          Page not found
        </h1>
        <p className="text-lg sm:text-xl font-medium leading-relaxed text-gray-500 max-w-2xl mx-auto mb-10">
          The page you are looking for does not exist or may have been moved.
        </p>

        <Link
          to="/"
          className="inline-flex items-center justify-center gap-3 rounded-2xl bg-red-600 px-6 py-4 text-sm sm:text-base font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_rgba(220,38,38,0.25)] transition-all hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-[0_15px_40px_rgba(220,38,38,0.35)] active:scale-[0.98]"
        >
          <ArrowLeft className="h-5 w-5" />
          Back to home
        </Link>
      </main>
    </div>
  );
};
